import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { BehaviorSubject } from 'rxjs';
import { attachmentMaster } from 'src/app/Models/BasicForms/attachmentMaster';
import { ApiService } from 'src/app/Service/api.service';
import { AttachmentDrawerComponent } from '../attachment-drawer/attachment-drawer.component';

@Component({
  selector: 'app-attachment-master',
  templateUrl: './attachment-master.component.html',
  styleUrls: ['./attachment-master.component.css']
})
export class AttachmentMasterComponent implements OnInit {
  @Input() data: attachmentMaster;
  @Input() dataType: number;

  constructor(public _apiService: ApiService, private notificationService: NzNotificationService) { }

  formTitle = "Attachments";

  ngOnInit(): void { }

  getAttachmentIDWise(type, typeID) {
    this.loadingRecords = true;
    let filterStr = " and TYPE=" + type + " and TYPE_ID=" + typeID;;

    this._apiService.getAllAttachments(this.pageIndex, this.pageSize, 'ID', 'desc', filterStr).subscribe(data => {

      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.attachmentData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["TYPE", "Type"], ["TYPE_ID", "Type ID"], ["USER_ID", "User ID"], ["ATTACHMENT_URL", "Attachment URL"], ["UPDATED_DATETIME", "Attached date Time"]];

  filterQuery: string = "";
  isloadSpinning = false;
  loadingRecords = false;
  attachmentData: [];

  getAllAttachments(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
      this.logtext = 'Filter Applied - Attachment Master form"+ sort +" "+this.sortKey +" KEYWORD [F - Attachment Master] ';
      this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
        if (successCode['code'] == "200") {

        }
        else {

        }
      });
    } catch (error) {
      sort = "";
    }


    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)

    }

    this.logtext = 'Filter Applied - Attachment Master form "+ likeQuery +" KEYWORD [F - Attachment Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });

    this._apiService.getAllAttachments(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery).subscribe(data => {

      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.attachmentData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }

  drawerVisible = false;
  drawerTitle = "";
  attachmentDrawerData: attachmentMaster = new attachmentMaster();

  typeForAttachmentDrawer: number;
  typeIDForAttachmentDrawer: number;

  add() {
    this.drawerVisible = true;
    this.drawerTitle = "Add Attachment";
    this.attachmentDrawerData = new attachmentMaster();
    this.attachmentDrawerData.IS_ACTIVE = true;

    this.attachmentDrawerData.TYPE = this.dataType;
    this.attachmentDrawerData.TYPE_ID = this.data.ID;

    this.typeForAttachmentDrawer = this.dataType;
    this.typeIDForAttachmentDrawer = this.data.ID;

    this.logtext = 'ADD - Attachment Master form KEYWORD [A - Attachment Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  edit(data: attachmentMaster) {
    this.drawerVisible = true;
    this.drawerTitle = "Attachment Details";
    this.attachmentDrawerData = Object.assign({}, data);

    this.attachmentDrawerData.TYPE = this.dataType;
    this.attachmentDrawerData.TYPE_ID = this.data.ID;

    this.typeForAttachmentDrawer = this.dataType;
    this.typeIDForAttachmentDrawer = this.data.ID;

    this.logtext = 'EDIT - Attachment Master form KEYWORD [E - Attachment Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  drawerClose() {
    this.getAttachmentIDWise(this.dataType, this.data.ID);
    this.drawerVisible = false;
  }

  get callBackDrawerClose() {
    return this.drawerClose.bind(this);
  }

  sortKey: string = "id";
  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'desc';



    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    // this.getAllWorklogs();
  }
}
